import { css } from '@bts-web/utils-style-engine';
import { FC } from 'react';
import { RegularDismissCircle } from '../../../../common/svgIcons';
import { HTMLRenderer } from '@bts-web/core-features/common';

export const FailContent: FC<{
  subtitleMessage: string;
}> = ({ subtitleMessage }) => {
  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'negative.text_primary',
        backgroundColor: 'negative.fill_focused',
        borderRadius: '16px',
        paddingTop: 'medium',
        paddingInlineStart: 'medium',
        paddingInlineEnd: 'medium',
        paddingBottom: 'large',
        fontSize: 'body.medium',
        gap: 'small',
        maxWidth: 330,
        mx: 'auto',
        textAlign: 'center',
      })}
      aria-label="fail content"
    >
      <RegularDismissCircle size={24} />

      <h1
        className={css({
          '& [data-element="markdown-style"]': {
            color: 'neutrals.text_secondary',
            whiteSpace: 'nowrap',
          },
        })}
      >
        <HTMLRenderer>{subtitleMessage}</HTMLRenderer>
      </h1>
    </div>
  );
};
